import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import ObjectUtils from '../../../../../modules/ObjectUtils';
import VerticalLabelList from '../../../../label/VerticalLabelList';
import FieldSet from '../../../../fieldset/FieldSet';
import Grid from '../../../../grid/Grid';
import { EMPTY_GRID_DEFAULT_MESSAGE, } from '../../../../../modules/Constants';

class JacksonDetailedBill extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { bill, } = this.props;
    const paymentTransactions = ObjectUtils.formatStringAsJSONArray(bill.paymentTransactions);
    const paymentTransactionModel = Grid.toModelFromList(paymentTransactions);
    const externalBillPayments = ObjectUtils.formatStringAsJSONArray(bill.externalBillPayments);
    const externalBillPaymentModel = Grid.toModelFromList(externalBillPayments);
    const taxReceiptIds = ObjectUtils.formatStringAsJSONArray(bill.taxReceiptIds);
    const externalReceipts = ObjectUtils.formatStringAsJSONArray(bill.externalReceipts);
    const externalReceiptModel = Grid.toModelFromList(externalReceipts);
    const distributions = ObjectUtils.formatStringAsJSONArray(bill.distributions);
    const distributionModel = Grid.toModelFromList(distributions);

    const items = VerticalLabelList.toList({
      Id: bill.id,
      'Due Date': moment(bill.dueDate)
        .utc()
        .format(),
      Paid: bill.paid,
      'Bill Amount': bill.initialAmount_value,
      'Bill Balance': bill.billBalance_value,
      'Client Bill Balance': bill.clientBillBalance_value,
      'PayIt Balance': bill.payitBillBalance_value,
      TaxYear: bill.taxYear,
      'External Bill Id': bill.externalBillId,
      Flags: bill.flags,
    });

    return (
      <div>
        <div style={{ marginTop: '50px', }}>
          <FieldSet title="Bill Summary" style={{ maxHeight: '200px', }}>
            <VerticalLabelList items={items} />
          </FieldSet>
        </div>

        <div style={{ marginTop: '20px', }}>
          <FieldSet title="Payment Transactions" style={{ maxHeight: '200px', }}>
            <Grid
              headers={paymentTransactionModel.headers}
              rows={paymentTransactionModel.format(paymentTransactions)}
              onEmptyGridMessage={EMPTY_GRID_DEFAULT_MESSAGE}
            />
          </FieldSet>
        </div>

        <div style={{ marginTop: '20px', }}>
          <FieldSet title="External Bill Payments" style={{ maxHeight: '200px', }}>
            <Grid
              headers={externalBillPaymentModel.headers}
              rows={externalBillPaymentModel.format(externalBillPayments)}
              onEmptyGridMessage={EMPTY_GRID_DEFAULT_MESSAGE}
            />
          </FieldSet>
        </div>
        <div style={{ marginTop: '20px', }}>
          <FieldSet title="Tax Receipt Ids" style={{ maxHeight: '200px', }}>
            <Grid
              headers={[ { value: 'taxReceiptIds', display: 'Tax Receipts', }, ]}
              rows={taxReceiptIds.map(v => ({ value: [ v, ], raw: v, }))}
              onEmptyGridMessage={EMPTY_GRID_DEFAULT_MESSAGE}
            />
          </FieldSet>
        </div>

        <div style={{ marginTop: '20px', }}>
          <FieldSet title="External Receipts" style={{ maxHeight: '200px', }}>
            <Grid
              headers={externalReceiptModel.headers}
              rows={externalReceiptModel.format(externalReceipts)}
              onEmptyGridMessage={EMPTY_GRID_DEFAULT_MESSAGE}
            />
          </FieldSet>
        </div>
        <div style={{ marginTop: '20px', }}>
          <FieldSet title="Distributions" style={{ maxHeight: '200px', }}>
            <Grid
              headers={distributionModel.headers}
              rows={distributionModel.format(distributions)}
              onEmptyGridMessage={EMPTY_GRID_DEFAULT_MESSAGE}
            />
          </FieldSet>
        </div>
      </div>
    );
  }
}

JacksonDetailedBill.propTypes = {
  bill: PropTypes.instanceOf(Object).isRequired,
};

export default JacksonDetailedBill;
